module.exports = __webpack_public_path__ + "img/house_19.cfd83a55.jpg";